import { CancellableResult } from '../../../common/result';
import { Action } from '../../../config';
import faceAuthentication, { Authentication } from '../../../services/faceAuthentication';
import CompleteUniquenessTask from '../background/CompleteUniquenessTask';
import StepWorker, { StepWorkerResult } from './StepWorker';

export default class FaceUniquenessStep implements StepWorker {
  public requiresInit = false;

  public userDid: string;

  private action: Action;

  constructor(userDid: string, action: Action = Action.ISSUANCE) {
    this.userDid = userDid;
    this.action = action;
  }

  public async processStep(validationId: string): Promise<StepWorkerResult> {
    const result =
      this.action === Action.REFRESH
        ? await faceAuthentication.authenticate(this.userDid, false)
        : await faceAuthentication.faceIdAuthenticate(this.userDid);

    if (result.isCancelled()) {
      return { result: CancellableResult.cancelled(result.getDetail()) };
    }

    if (result.isFailed()) {
      return { result: CancellableResult.failed(result.failure(), result.getDetail()) };
    }

    const uniquenessResult = result.success(result.getDetail()) as Authentication;

    return {
      result: CancellableResult.noValueSuccess(result.getDetail()),
      backgroundTask: new CompleteUniquenessTask(validationId, {
        ...uniquenessResult,
      }),
    };
  }
}
